import { ActionMenu } from '@/components/ui/ActionMenu';
import { useAuth } from '@/features/auth/useAuth';
import { FeedbackModal } from '@/features/feedback/components/FeedbackWidget';
import { useTheme } from '@/features/theme/useTheme';
import { USER_ROLE_LABELS } from '@coreltb/shared/constants';
import { LogOut, MessageSquarePlus, Moon, Sun } from 'lucide-react';
import { useState } from 'react';

export function initialsOf(name: string): string {
  return (
    name
      .split(/\s+/)
      .map((p) => p.charAt(0).toUpperCase())
      .slice(0, 2)
      .join('') || '?'
  );
}

/**
 * Menu profilu (awatar w pasku gornym): motyw, zglos uwage, wyloguj.
 * Zastepuje 3 osobne ikony w pasku i plywajacy przycisk uwag.
 */
export function UserMenu({ onLogout }: { onLogout: () => void }) {
  const { user } = useAuth();
  const { resolved, setPref } = useTheme();
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  if (!user) return null;
  const isDark = resolved === 'dark';

  return (
    <>
      <ActionMenu
        label="Menu profilu"
        triggerVariant="ghost"
        // p-0 takze od md: wariant przycisku dodaje md:px-3.5, ktory sciskal kolko w pigulke.
        triggerClassName="h-touch w-touch shrink-0 rounded-full p-0 md:h-9 md:w-9 md:p-0"
        trigger={
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-subtle text-xs font-semibold text-accent ring-1 ring-accent/30">
            {initialsOf(user.name)}
          </span>
        }
        header={
          <div className="min-w-0">
            <div className="truncate text-sm font-semibold text-fg">{user.name}</div>
            <div className="truncate text-xs text-fg-muted">
              {USER_ROLE_LABELS[user.role] ?? user.role}
              {user.actualRole !== user.role && ' (wcielenie)'}
            </div>
          </div>
        }
        items={[
          {
            label: isDark ? 'Motyw jasny' : 'Motyw ciemny',
            icon: isDark ? Sun : Moon,
            onSelect: () => setPref(isDark ? 'light' : 'dark'),
          },
          {
            label: 'Zgłoś uwagę do tej strony',
            icon: MessageSquarePlus,
            onSelect: () => setFeedbackOpen(true),
          },
          'separator',
          { label: 'Wyloguj', icon: LogOut, onSelect: onLogout, tone: 'danger' },
        ]}
      />
      {feedbackOpen && <FeedbackModal onClose={() => setFeedbackOpen(false)} />}
    </>
  );
}
